import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { Configuration, MyContextApi } from '../generated/openapi/befunde-api';
import { loadUser } from '../oidcConfig.ts';

const api = new MyContextApi(new Configuration({ accessToken: () => loadUser()?.access_token ?? '' }), window._env_.API_URL);

export const useGetMyLabIdentifiers = () =>
  useQuery<string[], AxiosError>({
    queryKey: [api.getMyLabIdentifiers.name],
    queryFn: async () => {
      const res = await api.getMyLabIdentifiers();
      return res?.data;
    },
    retry: false,
    refetchOnMount: false, // do not fetch multiple times on page load
  });
